import { render } from "./Footer.vue?vue&type=template&id=ffce1590&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=ffce1590&lang=scss&scoped=true"

import exportComponent from "/Users/zhouyuan/work/project/cargpsweb-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffce1590"]])

export default __exports__